import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, canonical, schemas = [] }) => {
  const siteTitle = "AlbertaRank";
  const finalTitle = title ? `${title}` : `${siteTitle} | Alberta's AI-First SEO Agency`;
  const finalDesc = description || "AlbertaRank provides specialized SEO and AEO services for Calgary and Edmonton home service businesses using the Truth Protocol™.";

  // Default Organization Schema
  const defaultOrgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "AlbertaRank",
    "url": "https://albertarank.pro",
    "logo": "https://albertarank.pro/logo.png",
    "description": "Alberta's leading Answer Engine Optimization agency specializing in home services.",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Calgary",
      "addressRegion": "AB",
      "addressCountry": "CA"
    }
  };

  const allSchemas = [defaultOrgSchema, ...schemas];

  return (
    <Helmet>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDesc} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDesc} />
      <meta property="og:type" content="website" />
      
      {canonical && <link rel="canonical" href={canonical} />}

      {allSchemas.map((schema, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};

export default SEO;